<div class="content-pane">
  @if (helpService.visibleHelpSections(); as sections) {
    @if (sections.length === 0) {
      <div>
        <b>Something went wrong while loading the page. Please reload the page.</b>
      </div>
    }

    @for (section of sections; track section.slug) {
      <mat-expansion-panel
        [class.main-section-panel]="true"
        #sectionPanelRef
        (expandedChange)="toggleSection(section.slug, $event)"
        [attr.aria-expanded]="isSectionExpanded(section)"
        [attr.data-slug]="section.slug"
        [expanded]="isSectionExpanded(section)"
        class="help-section"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ section.title }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        @if (section.content) {
          <div [innerHTML]="section.content"></div>
        }

        @for (subsection of section.subsections; track subsection.slug) {
          <mat-expansion-panel
            [class.subsection-panel]="true"
            #subsectionPanelRef
            (expandedChange)="toggleSection(section.slug + '-' + subsection.slug, $event)"
            [attr.aria-expanded]="isSubsectionExpanded(section.slug, subsection)"
            [attr.data-slug]="subsection.slug"
            [expanded]="isSubsectionExpanded(section.slug, subsection)"
            class="help-subsection"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ subsection.title }}
              </mat-panel-title>
            </mat-expansion-panel-header>

            @if (subsection.content) {
              <div [innerHTML]="subsection.content" class="subsection-content"></div>
            }

            @for (tertiary of subsection.subsections; track tertiary.slug) {
              <mat-expansion-panel
                [class.tertiary-panel]="true"
                #tertiaryPanelRef
                (expandedChange)="toggleSection(section.slug + '-' + subsection.slug + '-' + tertiary.slug, $event)"
                [attr.aria-expanded]="isTertiarySectionExpanded(section.slug, subsection.slug, tertiary)"
                [attr.data-slug]="tertiary.slug"
                [expanded]="isTertiarySectionExpanded(section.slug, subsection.slug, tertiary)"
                class="help-tertiary-section"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{ tertiary.title }}
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <div [innerHTML]="tertiary.content" class="tertiary-content"></div>
              </mat-expansion-panel>
            }
          </mat-expansion-panel>
        }
      </mat-expansion-panel>
    }
  } @else {
    <div><b>Loading help content... </b></div>
  }
</div>
